import { hasValue, isString } from 'swipeclock-frontend';

export function getTabURL({ title }) {
  return hasValue(title) && isString(title)
    ? `/${title.trim().toLowerCase()}`
    : '';
}

// Takes the route from the anchor and the current pathname
// and then returns the URL to navigate to.
// The /pathname/anchor.route is the URL to navigate to.
export function getDrawerURL({ anchor }, { pathname }) {
  const base = pathname?.split('/')[1];
  if (hasValue(anchor?.route) && hasValue(base)) {
    return `/${base}/${anchor?.route}`;
  }

  // no drawer route found return empty string
  return '';
}

// Take off sub route from pathname
// /companies/company-dashboard -> /companies
export function stripSubRoute(pathname) {
  const parts = pathname.split('/');

  // Doesn't need to change
  if (parts.length <= 2) {
    return pathname;
  }

  return parts.slice(0, parts.length - 1).join('/');
}

export async function createLazyRoute(page, store) {
  try {
    // Dynamically import the component, loader, and action from the page directory.
    const { action, loader, Component } = await import(`pages/${page}`);

    // Return the lazy route object.
    return {
      action: action
        ? ({ params, request }) => action(store, { params, request })
        : undefined,
      loader: loader
        ? ({ params, request }) => loader(store, { params, request })
        : undefined,
      Component, // Ensure you return the element to render the component.
    };
  } catch (error) {
    console.error('Error loading route:', error);
    throw error;
  }
}

export const redirectToLogin = ({
  employeeLogonUrl,
  shugoLogonUrl,
  useShugoLogonUrl,
}) => {
  if (useShugoLogonUrl) {
    window.location.href = shugoLogonUrl;
  } else if (!useShugoLogonUrl && hasValue(employeeLogonUrl)) {
    window.location.href = employeeLogonUrl;
  } else {
    // Get base url from current url
    console.warn('Could not redirect to login. Using default login URL.');
    const currentUrl = new URL(window.location.href);
    window.location.href = `${currentUrl.origin}/login`;
  }
};

export const redirectToPartnerLogin = ({
  partnerLogonUrl,
  usePartnerLogonUrl,
}) => {
  if (usePartnerLogonUrl) {
    window.location.href = partnerLogonUrl;
  } else {
    // Get base url from current url
    console.warn('Could not redirect to login. Using default login URL.');
    const currentUrl = new URL(window.location.href);
    window.location.href = `${currentUrl.origin}/login`;
  }
};
